// Hook do pobierania dostępnych eventów domenowych

import { axios } from 'api';
import { useQuery, UseQueryOptions } from 'react-query';
import { ICommandResponseError as IError } from 'api/types';

export interface IDomainEvent {
  value: string;
  text: string;
}

interface IResponse {
  items: IDomainEvent[];
}

const getDomainEvents = (): Promise<IResponse> =>
  axios.get('/dev-studio/process/events-domain');

export const useGetDomainEvents = (
  options?: UseQueryOptions<IResponse, IError>
) => useQuery<IResponse, IError>(['domainEvents'], () => getDomainEvents(), options);
